var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SalesReportTemplate',{attrs:{"title":"Sales Report by Classification","columns":_vm.columns,"fetchRoute":"/reports/sales-by-classification","permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_SALES_BY_CLASSIFICATION,"reportTypeCode":_vm.REPORT_MASTER_CODES.SALES_BY_CLASSIFICATION}})
}
var staticRenderFns = []

export { render, staticRenderFns }